import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { ClaimStatus } from '../../types';

interface LADClaimInitialValuesApi {
  customerKey: number;
  currencyCode: string;
  consigneeCountryCode: string;
  claimType: number;
  claimStatus: ClaimStatus;
  claimReason: string;
  claimReasonType: string;
  shipperCountryCode: string;
}

export const getLADClaimInitialValuesAPI = () => {
  return axiosInstance.request({
    url: `${API.LOSS_AND_DAMAGE}/GetInitialClaimData`,
    method: 'get',
  });
};

export type LADClaimInitialValuesResponse = LADClaimInitialValuesApi;

export const fetchLADClaimInitialValues = async (): Promise<LADClaimInitialValuesResponse> => {
  const response: AxiosResponse<LADClaimInitialValuesResponse> = await getLADClaimInitialValuesAPI();
  return response.data;
};
